import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from '@mui/material';
import dayjs from 'dayjs';
import GlassmorphismCard from './GlassmorphismCard';
import SpanTag from '../FormFields/SpanTag';
import { H5, Body3 } from '../../themes/typography';
import { formatDayMonth } from '../../utils/dateFormatter';
import '../../styles/components/EventCard.css';

const eventOrganizerAvatar =
    'https://img.freepik.com/free-photo/3d-illustration-teenager-with-funny-face-glasses_1142-50955.jpg?t=st=1721627721~exp=1721631321~hmac=59e0f2165b23e83a9090d820c1a64bad1f41ccce3a6b6b81dc358143b1ba99b0&w=740';
const eventThumbnail =
    'https://img.freepik.com/free-photo/female-wedding-planner-working-with-couple_23-2150167186.jpg?t=st=1726035190~exp=1726038790~hmac=21ca86d3074888c9b13e019a9cb587dd647d7e3faf550830b37a530841537e37&w=740';

export default function EventMainCard({
    slug = 'summer-music-festival-concert-2025',
    thumbnail = eventThumbnail,
    organizerAvatar = eventOrganizerAvatar,
    name = 'Summer Music Festival Concert 2025',
    location = 'Downtown Park, New York City London',
    startingTime = '18:00:00',
    price = '399',
    startingDate = '2024-12-15',
    format = [],
}) {

    const displayStartingTime = (() => {
        if (!startingTime) return '';

        // Attach today's date so dayjs can parse time correctly
        const parsed = dayjs(`1970-01-01 ${startingTime}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm']);

        if (parsed.isValid()) {
            return parsed.format('hh:mm A') + ' Onwards'; // 12hr format + AM/PM
        }

        // If backend already sends "03:30 PM", just return it with Onwards
        return startingTime + ' Onwards';
    })();


    const { day, month } = formatDayMonth(startingDate);

    const [showViewDetail, setShowViewDetail] = useState(false);

    return (
        <Link
            className="normal-event-card-container"
            onMouseEnter={() => setShowViewDetail(true)}
            onMouseLeave={() => setShowViewDetail(false)}
            to={`/e/${slug}`}
        >

            <div className="normal-event-card-image-section">
                <img src={thumbnail} alt="Thumbnail" />
            </div>

            <div className="normal-event-details-section-container">

                <div className="normal-event-card-user-avatar">
                    <AvatarDesign src={organizerAvatar} />
                </div>

                <div className="normal-event-card-title-format-section">
                    <div className="event-title-section-container">
                        <H5 color="var(--secondary-color)" fontWeight={600}>
                            {name}
                        </H5>
                    </div>

                    <div className="event-format-section-container">
                        <div className="event-format-container">
                            <SpanTag eventFormatTag={format[0]?.name} />
                        </div>
                    </div>
                </div>

                <div className="event-place-date-section-container">
                    <div className="event-place-details-section-container">

                        <div className="event-location-section">
                            <Body3>
                                {location}
                            </Body3>
                        </div>

                        <div className="event-timing-section">
                            <Body3>
                                {displayStartingTime}
                            </Body3>
                        </div>

                        <div className="event-pricing-section">
                            <Body3>
                                {Number(price) > 0
                                    ? (
                                        <>
                                            Starting ₹{price}
                                            {/* Starting ₹{parseFloat(price).toFixed(2).replace(/\.00$/, '')} */}
                                        </>
                                    )
                                    : "Free"
                                }
                            </Body3>
                        </div>
                    </div>

                    <div className="event-date-details-section-container">
                        <div className="event-date-section">
                            <H5 color="var(--secondary-color)" fontWeight={600}>
                                {day}
                                <sup>th</sup>
                            </H5>
                            <H5 color="var(--secondary-color)" fontWeight={600}>
                                {month}
                            </H5>
                        </div>
                    </div>
                </div>
            </div>

            <GlassmorphismCard isShown={showViewDetail} />
        </Link>
    );
}

function AvatarDesign({
    alt = 'Avatar',
    src = 'https://img.freepik.com/free-photo/3d-illustration-teenager-with-funny-face-glasses_1142-50955.jpg?t=st=1721627721~exp=1721631321~hmac=59e0f2165b23e83a9090d820c1a64bad1f41ccce3a6b6b81dc358143b1ba99b0&w=740',
    sx = {
        width: 42,
        height: 42
    }
}) {
    return <Avatar size="lg" variant="soft" alt={alt} src={src} sx={sx} />;
}